import React, { useCallback } from "react";
import "./styles.scss";
import { useParams } from "react-router-dom";
import {
  getApplicationManageData,
  getApplicationManageDataFromSalesforce,
  getJobScheduleDetails,
  getNHEAppointment,
  getStartDateInfo,
} from "../../utility/application-data";
import { ApplicationStatusUncontrolled } from "./application-status-uncontrolled";
import { isSalesforceApplication } from "../../helpers/url-params";

export const ApplicationStatus = () => {
  const { applicationId } = useParams<{
    applicationId: string;
  }>();

  const nheAccessor = useCallback(() => {
    return getNHEAppointment(applicationId);
  }, []) as any;

  const sdaAccessor = useCallback(() => {
    return getStartDateInfo(applicationId);
  }, []) as any;

  const jcAccessor = useCallback(() => {
    return getJobScheduleDetails(applicationId);
  }, []) as any;

  // const applicationManageAccessor = useCallback(() => {
  //   return getApplicationManageData(applicationId);
  // }, []) as any;

  let applicationManageAccessor;
  if (!isSalesforceApplication(applicationId)) {
    applicationManageAccessor = useCallback(() => {
      return getApplicationManageData(applicationId);
    }, []) as any;
  } else {
    applicationManageAccessor = useCallback(() => {
      return getApplicationManageDataFromSalesforce(applicationId);
    }, []) as any;
  }

  return (
    <ApplicationStatusUncontrolled
      nheAccessor={nheAccessor}
      sdaAccessor={sdaAccessor}
      jcAccessor={jcAccessor}
      applicationManageAccessor={applicationManageAccessor}
    />
  );
};
